export interface ICreditNoteResponse {
  errors: string[];
  message: string;
  succeeded: boolean;
  data: ICreditNote;
}

export interface ICreditNote {
  invoiceId: number;
  reason: string;
  reasonId: number;
  invoice: any; // TODO: Define IInvoice interface if needed
  number: string;
  createdAt: string;
  dueDate: string;
  subtotal: number;
  tax: number;
  orderNumber: string;
  customerId?: number;
  customer: any; // TODO: Define ICustomer interface if needed
  quotationNumber: string;
  reference: string;
  total: number;
  totalTax: number;
  itemCount: number;
  totalDiscount: number;
  attachmentId?: number;
  attachment: any;
  signatureId?: number;
  signature: any; // TODO: Define IInvoiceSignature interface if needed
  branchId?: number;
  branch: any;
  documentFile: string;
  hasDownloadedInvoiceBefore: boolean;
  id: number;
  lpoNumber: string;
  destinationCountry: string;
  items: ICreditNoteItem[];
  status: number;
  currency: string;
  exchangeRate?: number;
  name: string;
  updatedAt: string;
}

export interface ICreditNoteItem {
  id: number;
  invoiceItemId: number;
  itemCode: string;
  itemName: string;
  quantity: number;
  price: number;
  discountRate: number;
  discountAmount: number;
  taxRate: number;
  taxAmount: number;
  total: number;
  description: string;
} 